import { SECRET_KEY } from "config/secrets";
import CryptoJS from "crypto-js";

export const encryptAndStoreToken = (token) => {
  const encryptedToken = CryptoJS.AES.encrypt(token, SECRET_KEY).toString();
  return encryptedToken;
};

export const getDecryptedToken = (encryptedToken) => {
  if (encryptedToken) {
    const bytes = CryptoJS.AES.decrypt(encryptedToken, SECRET_KEY);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedToken;
  }
  return null; // Handle case where token is not available
};
